(() => {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  const SELECTOR = '#MainContent > .shopify-section, footer > .shopify-section';
  const CHILD_SELECTOR = [
    '.drop-products__cell',
    '.drop-products-hub__card',
    '.drop-product-info__card',
    '.how-it-works__step',
    '.the-process__step',
    '.group-drop__perk',
    '.faq__item',
  ].join(', ');

  const observer = new IntersectionObserver(
    (entries) => {
      for (const entry of entries) {
        if (!entry.isIntersecting) continue;
        entry.target.classList.add('is-in');
        staggerChildren(entry.target);
        observer.unobserve(entry.target);
      }
    },
    {
      threshold: 0.12,
      rootMargin: '0px 0px -6% 0px',
    }
  );

  const staggerChildren = (section) => {
    if (!(section instanceof HTMLElement)) return;
    const children = section.querySelectorAll(CHILD_SELECTOR);
    children.forEach((child, index) => {
      if (!(child instanceof HTMLElement)) return;
      child.style.setProperty('--drop-reveal-child-delay', `${Math.min(index, 8) * 55}ms`);
      child.classList.add('drop-reveal-child', 'is-in');
    });
  };

  const prepare = (section, index = 0) => {
    if (!(section instanceof HTMLElement)) return;
    if (section.classList.contains('drop-reveal') || section.classList.contains('is-in')) return;

    const top = section.getBoundingClientRect().top;
    if (top < window.innerHeight * 0.88) {
      // Already in view: still stagger children lightly
      const children = section.querySelectorAll(CHILD_SELECTOR);
      children.forEach((child, childIndex) => {
        if (!(child instanceof HTMLElement)) return;
        child.style.setProperty('--drop-reveal-child-delay', `${Math.min(childIndex, 6) * 40}ms`);
        child.classList.add('drop-reveal-child');
        requestAnimationFrame(() => child.classList.add('is-in'));
      });
      return;
    }

    section.style.setProperty('--drop-reveal-delay', `${Math.min(index, 2) * 70}ms`);
    section.classList.add('drop-reveal');

    // Prepare children before reveal so they animate with the section
    section.querySelectorAll(CHILD_SELECTOR).forEach((child, childIndex) => {
      if (!(child instanceof HTMLElement)) return;
      child.style.setProperty('--drop-reveal-child-delay', `${Math.min(childIndex, 8) * 55}ms`);
      child.classList.add('drop-reveal-child');
    });

    observer.observe(section);
  };

  const init = () => {
    document.querySelectorAll(SELECTOR).forEach((section, index) => {
      prepare(section, index);
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', (event) => {
    const section = event.target;
    if (section instanceof HTMLElement && (section.closest('#MainContent') || section.closest('footer'))) {
      prepare(section);
    }
  });
})();
